import users from "./modules/users";
import cps from "./modules/cps";
import cp_requests from "./modules/cp_requests";
import cp_sessions from "./modules/cp_sessions";
import roles from "./modules/roles";
import accounts from "./modules/accounts";
import privileges from "./modules/privileges";
import user_log from "./modules/user_log";
import cp_zones from "./modules/cp_zones";
import cp_locs from "./modules/cp_locs";
import cp_pow from "./modules/cp_pow";
import lms_profiles from "./modules/lms_profiles";
import account_service_plans from "./modules/account_service_plans";
import service_plans from "./modules/service_plans";
import account_vehicles from "./modules/account_vehicles";
import cp_sessions_all from "./modules/cp_sessions_all";
import kmb_cp_sessions from "./modules/kmb_cp_sessions";
import auth_card from "./modules/auth_card";
import opening_hour from "./modules/opening_hour";
import contact from "./modules/contact";
import contact_group from "./modules/contact_group";
import alert from "./modules/alert";
import cp_rsr from "./modules/cp_rsr";
import cp_rsr_request from "./modules/cp_rsr_request";
import cp_rsr_api_log from "./modules/cp_rsr_api_log";
import charging_rate from"./modules/charging_rate";
import payment_result_detail from "./modules/payment_result_detail";
import third_party_error_log from "./modules/third_party_error_log";
import charging_rate_detail from "./modules/charging_rate_detail";
import bay from "./modules/bay"
import bay_log from "@/settings/crud/modules/bay_log";
import user_profile from "./modules/user_profile";
import portal_action_log from "./modules/portal_action_log"
import voucher from "./modules/voucher"

export default {
  users,
  cps,
  cp_requests,
  cp_sessions,
  accounts,
  roles,
  privileges,
  user_log,
  cp_zones,
  cp_locs,
  cp_pow
  ,
  lms_profiles,
  account_service_plans,
  service_plans,
  account_vehicles,
  cp_sessions_all,
  auth_card,
  opening_hour,
  contact,
  contact_group,
  alert,
  kmb_cp_sessions,
  auth_card,
  cp_rsr,
  cp_rsr_request,
  cp_rsr_api_log,
  charging_rate,
  payment_result_detail,
  third_party_error_log,
  charging_rate_detail,
  bay,
  bay_log,
  user_profile,
  portal_action_log,
  voucher
};